import { useEffect, useState } from "react";
import ListView from "../listview";
import _ from "lodash";
import Error from 'next/error';

const Topics = () => {
  const [typeID, setID] = useState();
  const [tag, setTag] = useState('');

  useEffect(() => {
    //get the type id from url path
    if (typeof window !== "undefined") {
      let path = window.location.pathname;
      let data = _.split(path, '/', 4);

      if (data[3] && data[3].length == 3) {
        setID(data[3]);
      } 
      else {
        setID(null);
      }

      if (window.location.href.indexOf('?tag=') > 0) {
        let tag = window.location.href.split('?tag=')[1];
        setTag(tag);
      }
    }
  }, []);

  // normal
  if (typeID) {
    return (<ListView topicID={typeID} tag={tag} />);
  } 
  // type id not valid
  else if (typeID === null) {
    return <Error statusCode='404' />
  } 
  else {
    return <></>
  }

}

export default Topics;